var config = require('./config.global');

config.env = 'test';
config.hostname = 'test.example';

module.exports = config;
